// Live Tours — per-tour editor route.
// -----------------------------------------------------------------
// Per docs/architecture/dispatches/m7-2-production-tour-editor.md
// § 4 M7.2-E.
//
// Renders <LiveTourEditor tourId={params.tourId}> when the flag is on.
// Redirects to /hello when the flag is off.
//
// The trailing underscore in `live-tours_` opts this route OUT of
// nesting under the `live-tours.tsx` layout component (TanStack
// Router flat-file convention), so <LiveTourEditor> mounts directly
// without requiring an <Outlet /> in the parent.
// URL: /live-tours/$tourId.  Route id:
// /_authenticated/live-tours_/$tourId.

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { LiveTourEditor } from '@/components/live-tours/LiveTourEditor';
import { isFeatureEnabled } from '@/lib/featureFlags';

const LiveTourEditorRoute = () => {
  const { tourId } = Route.useParams();
  if (!isFeatureEnabled('LIVE_TOURS')) {
    return <Navigate to='/hello' replace />;
  }
  return <LiveTourEditor tourId={tourId} />;
};

export const Route = createFileRoute('/_authenticated/live-tours_/$tourId')({
  component: LiveTourEditorRoute,
});
